import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";


export const Testimonials = ({ data }) => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1120 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1120, min: 850 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 850, min: 0 },
      items: 1,
    },
  };

  if (!data || data.length === 0) return null;

  if (data.length <= 2) {
    return (
      <div
        className="d-flex justify-content-center align-items-stretch flex-wrap gap-3 m-auto py-2"
        style={{ maxWidth: '1140px' }}
      >
        {data.map((el, index) => (
          <div
            key={index}
            className="d-flex align-items-stretch"
            style={{ flex: '1 1 420px', maxWidth: '540px', minWidth: '300px' }}
          >
            {el}
          </div>
        ))}
      </div>
    );
  }

  return (
    <Carousel
      responsive={responsive}
      infinite={true}
      autoPlay={false}
      arrows={true}
      autoPlaySpeed={2500}
      showDots={false}
    >
      {data?.map((el, index) => {
        return (
          <div key={index} className="m-auto">
            <br />
            <br />
            {el}
          </div>
        );
      })}
    </Carousel>
  );
};